import { translations } from '../utilities/translations';

const useTranslation = () => {
  const searchParams = new URLSearchParams(window.location.search);

  // Default to English if 'lang' query param isn't 'ar'
  const lang = searchParams.get('lang') === 'ar' ? 'ar' : 'en';

  const t = (key) => translations[lang][key] || key;

  return { t, lang };
};

export default useTranslation;
